import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AccountComponent } from './components/account/account.component';
import { LoginFormComponent } from './components/account/login-form/login-form.component';
import { RegistrationFormComponent } from './components/account/registration-form/registration-form.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminAuthGuard } from './services/admin-auth-guard';
import { CityFormComponent } from './components/admin/city/form/city-form.component';
import { CityIndexComponent } from './components/admin/city/index/city-index.component';
import { MkmFormComponent } from './components/admin/mkm/form/mkm-form.component';
import { MkmIndexComponent } from './components/admin/mkm/index/mkm-index.component';
import { StateFormComponent } from './components/admin/state/form/state-form.component';
import { StateIndexComponent } from './components/admin/state/index/state-index.component';
import { TzadikimFormComponent } from './components/admin/tzadikim/form/tzadikim-form.component';
import { TzadikimIndexComponent } from './components/admin/tzadikim/index/tzadikim-index.component';
import { AdvertisementComponent } from './components/advertisement/advertisement.component';


export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'account', component: AccountComponent, children:
            [{ path: 'registration', component: RegistrationFormComponent },
            { path: 'login', component: LoginFormComponent }]
    },
     {
        path: 'admin', component: AdminComponent,
        canActivate: [AdminAuthGuard],
        children:
                [{path: 'state', children:
                [{ path: 'index', component: StateIndexComponent},
                    { path: 'new', component: StateFormComponent }]},
                { path: 'state/:id', component: StateFormComponent },
                {path: 'city', children:
                    [{ path: 'index', component: CityIndexComponent },
                        { path: 'new', component: CityFormComponent }]},
                { path: 'city/:id', component: CityFormComponent },
                {path: 'mkm', children:
                    [{ path: 'index', component: MkmIndexComponent },
                        { path: 'new', component: MkmFormComponent }]},
                { path: 'mkm/:id', component: MkmFormComponent },
                {path: 'tzadikim', children:
                    [{ path: 'index', component: TzadikimIndexComponent },
                        { path: 'new', component: TzadikimFormComponent }]},
                { path: 'tzadikim/:id', component: TzadikimFormComponent }
            ]                  
        },
        {
            path:'ads',
            component:AdvertisementComponent,
            canActivate:[AdminAuthGuard]
        }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        paramsInheritanceStrategy: 'always'
    })],
    exports: [RouterModule],
    providers:[AdminAuthGuard]
})
export class AppRoutingModule {
}